import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    ThemeProvider,
    Tooltip,
    Typography,
    useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    GetLabOrders,
    GetLabOrderDocuments,
    InsertPPLogs,
} from "../../../../api";
import NavBar from "../../../../components/Navbar";
import { LabOrder } from "../../../../store";
import UseStyle from "../../../../css/styles";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LoadingButton } from "@mui/lab";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from '@mui/icons-material/Print';

// Update log
// FB  9464   10/08/2024  KI    created new screen for displaying lab orders
// FB  10077  02/13/2025  SK  Patient Portal Issues 2.6.25

export default function LabOrdering() {
    const matches = useMediaQuery("(min-width:600px)");
    const styles = UseStyle();
    const navigate = useNavigate();
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [docs, setDocs] = useState<LabOrder[]>();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [rowsArray, setRowsArray] = useState([10, 15, 20]);
    const [viewLoaderArray, setViewLoaderArray] = useState<Array<number>>([]);
    const [pdfLoaderArray, setPDFLoaderArray] = useState<Array<number>>([]);
    const [printLoaderArray, setPrintLoaderArray] = useState<Array<number>>([]);
    const [open, setOpen] = useState(false);
    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const stylestop = {
        container: {
            width: matches == false ? "250" : "567px",
            border: "1px grey",
            backgroundColor: "white",
            padding: matches == false ? "32px 16px" : "32px 40px",
            height: "auto",
        },
    };

    async function GetLabOrder() {
        var data = sessionStorage.getItem("user");
        if (data != null) {
            const user = JSON.parse(data);
            if (user.EMRID != null) {
                const data = await GetLabOrders(user.EMRID);
                setDocs(data);
            }
        }
    }

    async function LoadDocument(doc: any) {
        console.log(doc);
        setPDFLoaderArray([...pdfLoaderArray, doc.LAB_ORDER_N]);
        const data = await GetLabOrderDocuments(doc.LAB_ORDER_N);
        if (data != undefined) {
            var file = new Blob([data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            var filename = patientName + "_" + new Date().getTime() + ".pdf";
            var element = document.createElement("a");
            element.setAttribute("href", fileURL);
            element.setAttribute("download", filename);
            element.dataset.downloadurl = [
                "application/pdf",
                element.download,
                element.href,
            ].join(":");
            element.draggable = true;
            element.classList.add("dragout");
            element.click();
        }
        setPDFLoaderArray(pdfLoaderArray.filter((la) => la != doc.LAB_ORDER_N));
        InsertPPLogs(
            "Downloading lab order",
            window.location.href,
            userName,
            ""
        );
    }

    async function ViewDocument(document: any) {
        setViewLoaderArray([...viewLoaderArray, document.LAB_ORDER_N]);
        const pdfBlob = await GetLabOrderDocuments(document.LAB_ORDER_N);        
        if (pdfBlob) {
            const pdfUrl = URL.createObjectURL(pdfBlob);           
            setPdfUrl(pdfUrl);
            setOpen(true);
        }
        
        setViewLoaderArray(viewLoaderArray.filter((la) => la !== document.LAB_ORDER_N));
        InsertPPLogs("Viewing Lab Orders", window.location.href, userName, "");
    }
    
    

    async function PrintDocument(doc: any) {
        setPrintLoaderArray([...printLoaderArray, doc.LAB_ORDER_N]);
        const data = await GetLabOrderDocuments(doc.LAB_ORDER_N);
        if (data != undefined) {
            var file = new Blob([data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            var iframe = document.createElement('iframe');
            document.body.appendChild(iframe);

            iframe.style.display = 'none';
            iframe.src = fileURL;
            iframe.onload = function () {
                setTimeout(function () {
                    iframe.focus();
                    iframe.contentWindow?.print();
                }, 1);
            };
        }
        setPrintLoaderArray(printLoaderArray.filter((la) => la != doc.LAB_ORDER_N));
        InsertPPLogs(
            "Printing lab order",
            window.location.href,
            userName,
            ""
        );
    }

    let patientName = "User";
    let userName: any;
    let data = sessionStorage.getItem("user");
    if (data != null) {
        patientName = JSON.parse(data).PatientFirstName;
        userName = JSON.parse(data).Login;
    }
    async function InsertLogs() {
        InsertPPLogs("Viewing Lab Orders", window.location.href, userName, "");
    }

    const [showSpinner, setShowSpinner] = useState(false);
    const theme = useTheme();
    const [messagesEnabled, setMessagesEnabled] = useState(false);// FB  10077

    useEffect(() => {
        setShowSpinner(true);
        // FB  10077 - Begin
        let setting = sessionStorage.getItem("enable_portal_dashboard_options");
        const values = setting?.split(',').map(Number) || [];
        setMessagesEnabled(values.includes(2));
        // FB  10077 - End
        GetLabOrder();
        InsertLogs();
        setTimeout(() => {
            setShowSpinner(false);
        }, 3000);
    }, []);

    return (
        <>
            {matches && <NavBar />}
            {!matches && (
                <div
                    className="row"
                    style={{
                        paddingLeft: "25px",
                        paddingTop: "16px",
                        backgroundColor: "#F5F5F5",
                        fontWeight: "bold",
                    }}
                >
                   Lab Orders{" "}
                    <hr
                        style={{ height: "2px", border: "none", backgroundColor: "black" }}
                    ></hr>
                </div>
            )}
            <Grid
                container
                spacing={2}
                marginBottom="20px"
                marginTop="0.5px"
                style={
                    matches == false
                        ? {
                            backgroundColor: "#F5F5F5",
                        }
                        : {
                            paddingLeft: "80px",
                            backgroundColor: "#F5F5F5",
                        }
                }
            >
                <Grid
                    item
                    xs={12}
                    style={
                        matches == false
                            ? {
                                marginLeft: "16px",
                            }
                            : {}
                    }
                >
                    {" "}
                    {matches && (
                        <Typography variant="h5">
                            <b
                                style={{
                                    paddingTop: "20px",
                                    fontSize: "32px",
                                    fontWeight: "700",
                                    lineHeight: "40px",
                                }}
                            >
                                Lab Orders
                            </b>
                        </Typography>
                    )}
                    {matches && docs != undefined && docs.length > 0 ? (
                        <>
                            {/* FB  10077 - Begin */}
                            <Typography variant="subtitle1">
                                Lab Orders are posted as soon as they are available. 
                            </Typography>
                            {messagesEnabled &&(
                            <Typography variant="subtitle1">
                                If you have any follow-up questions,,Please <a href="/user/home/Messages">message</a> or{" "}
                                <a href="#">call</a> our office.
                            </Typography>
                            )}
                            {/* FB  10077 - End */}
                        </>
                    ) : (
                        <></>
                    )}
                </Grid>
                {docs != undefined && docs.length > 0 ? (
                    matches ? (
                        <Grid item>
                            <TableContainer
                                component={Paper}
                                sx={{ height: "510px", width: "100%", borderRadius: 0 }}
                            >
                                <Table
                                    stickyHeader
                                    size="small"
                                    aria-label="sticky table"
                                    style={{ tableLayout: "fixed" }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ fontSize: "1.2rem" }}>
                                                <b>Date</b>
                                            </TableCell>
                                            <TableCell style={{ fontSize: "1.2rem" }}>
                                                <b>Laboratory Name</b>
                                            </TableCell>
                                            <TableCell style={{ fontSize: "1.2rem" }}>
                                                <b>Physician</b>
                                            </TableCell>
                                            <TableCell style={{ fontSize: "1.2rem", textAlign: "center" }}>
                                                <b>Tools</b>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {docs?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((doc) => {
                                                return (
                                                    <TableRow>
                                                        <TableCell>
                                                            {doc.LAB_ORDER_MODIFY_DATE}
                                                        </TableCell>
                                                        <TableCell>
                                                            {doc.LABORATORY_NAME}
                                                        </TableCell>
                                                        <TableCell>
                                                            {doc.EMPLOYEE_FIRST_NAME}
                                                        </TableCell>
                                                        <TableCell style={{ textAlign: "center" }}>
                                                        <Tooltip title="View Document" placement="top-start">
                                                                <LoadingButton
                                                                    loading={viewLoaderArray.indexOf(doc.LAB_ORDER_N) > -1}
                                                                    loadingPosition="center"
                                                                    loadingIndicator={
                                                                        <CircularProgress
                                                                            size={20}
                                                                            style={{ color: "#083A4D" }}
                                                                        />
                                                                    }
                                                                    onClick={() => ViewDocument(doc)}
                                                                    startIcon={
                                                                        <VisibilityIcon style={{ color: viewLoaderArray.indexOf(doc.LAB_ORDER_N) > -1 ? "white" : "#083A4D" }} />
                                                                    }
                                                                />
                                                            </Tooltip>
                                                            <Tooltip title="Download PDF" placement="top-start">
                                                                <LoadingButton
                                                                    className={styles.textbutton}
                                                                    style={{ padding: "0px" }}
                                                                    loading={
                                                                        pdfLoaderArray.indexOf(doc.LAB_ORDER_N) > -1
                                                                    }
                                                                    loadingPosition="center"
                                                                    loadingIndicator={
                                                                        <CircularProgress
                                                                            size={20}
                                                                            style={{ color: "#083A4D" }}
                                                                        />
                                                                    }
                                                                    onClick={() => LoadDocument(doc)}
                                                                    startIcon={
                                                                        <DownloadIcon style={{ color: pdfLoaderArray.indexOf(doc.LAB_ORDER_N) > -1 ? "white" : "#083A4D" }} />
                                                                    }
                                                                />
                                                            </Tooltip>
                                                            <Tooltip title="Print Document" placement="top-start">
                                                                <LoadingButton
                                                                    className={styles.textbutton}
                                                                    style={{ padding: "0px" }}
                                                                    loading={
                                                                        printLoaderArray.indexOf(doc.LAB_ORDER_N) > -1
                                                                    }
                                                                    loadingPosition="center"
                                                                    loadingIndicator={
                                                                        <CircularProgress
                                                                            size={20}
                                                                            style={{ color: "#083A4D" }}
                                                                        />
                                                                    }
                                                                    onClick={() => PrintDocument(doc)}
                                                                    startIcon={
                                                                        <PrintIcon style={{ color: printLoaderArray.indexOf(doc.LAB_ORDER_N) > -1 ? "white" : "#083A4D" }} />
                                                                    }
                                                                />
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                    maxWidth: "1063px",
                                }}
                            >
                                <Grid container>
                                    <Grid item xs={8} display="flex">
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item>
                                                <span className={styles.TablePagination_text}>
                                                    Show{" "}
                                                </span>
                                            </Grid>
                                            <Grid item>
                                                <select
                                                    value={rowsPerPage}
                                                    onChange={(e) => handleChangeRowsPerPage(e)}
                                                    style={{
                                                        color: "#083A4D",
                                                        borderRadius: "5px",
                                                        padding: "8px, 16px, 8px, 16px",
                                                    }}
                                                >
                                                    {rowsArray.map((rows) => (
                                                        <option value={rows}>{rows}</option>
                                                    ))}
                                                </select>
                                            </Grid>
                                            <Grid item>
                                                <span className={styles.TablePagination_text}>
                                                    {" "}
                                                    per page
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={4} className={styles.flexend_Grid}>
                                        <IconButton
                                            onClick={() => setPage(page - 1)}
                                            disabled={page === 0}
                                            style={{ color: page === 0 ? "" : "#083A4D" }}
                                        >
                                            <PlayCircleOutlineIcon
                                                style={{ transform: "rotate(180deg)" }}
                                            />
                                        </IconButton>
                                        <IconButton
                                            onClick={() => setPage(page + 1)}
                                            disabled={
                                                page >=
                                                Math.ceil(
                                                    (docs ? docs.length : 0) / rowsPerPage
                                                ) -
                                                1
                                            }
                                            style={{
                                                color:
                                                    page >=
                                                        Math.ceil(
                                                            (docs ? docs.length : 0) / rowsPerPage
                                                        ) -
                                                        1
                                                        ? ""
                                                        : "#083A4D",
                                            }}
                                        >
                                            <PlayCircleOutlineIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    ) : (
                        <Grid container style={{ paddingLeft: "16px" }}>
                            {docs?.map((elem: any) => (
                                <Grid item xs={12} sm={6} md={3}>
                                    <Card>
                                        <CardContent>
                                            <Typography
                                                style={{ color: "#13607C" }}
                                            >
                                                {elem.LAB_ORDER_MODIFY_DATE}
                                            </Typography>
                                            <Typography style={{ color: "#13607C", fontWeight: "bold" }}>
                                                {elem.LABORATORY_NAME}
                                            </Typography>
                                            <Typography style={{ color: "#13607C", fontWeight: "bold" }}>
                                                {elem.EMPLOYEE_FIRST_NAME}
                                            </Typography>
                                            
                                            <Typography>
                                                <Tooltip title="View Document" placement="top-start">
                                                    <LoadingButton
                                                        loading={viewLoaderArray.indexOf(elem.LAB_ORDER_N) > -1}
                                                        loadingPosition="center"
                                                        loadingIndicator={
                                                            <CircularProgress
                                                                size={20}
                                                                style={{ color: "#083A4D" }}
                                                            />
                                                        }
                                                        onClick={() => ViewDocument(elem)}
                                                        startIcon={
                                                            <VisibilityIcon style={{ color: viewLoaderArray.indexOf(elem.LAB_ORDER_N) > -1 ? "white" : "#083A4D" }} />
                                                        }
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Download PDF" placement="top-start">
                                                    <LoadingButton
                                                        className={styles.textbutton}
                                                        style={{ padding: "0px" }}
                                                        loading={
                                                            pdfLoaderArray.indexOf(elem.LAB_ORDER_N) > -1
                                                        }
                                                        loadingPosition="center"
                                                        loadingIndicator={
                                                            <CircularProgress
                                                                size={20}
                                                                style={{ color: "#083A4D" }}
                                                            />
                                                        }
                                                        onClick={() => LoadDocument(elem)}
                                                        startIcon={
                                                            <DownloadIcon style={{ color: pdfLoaderArray.indexOf(elem.LAB_ORDER_N) > -1 ? "white" : "#083A4D" }} />
                                                        }
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Print Lab Order" placement="top-start">
                                                    <LoadingButton
                                                        className={styles.textbutton}
                                                        style={{ padding: "0px" }}
                                                        loading={
                                                            printLoaderArray.indexOf(elem.LAB_ORDER_N) > -1
                                                        }
                                                        loadingPosition="center"
                                                        loadingIndicator={
                                                            <CircularProgress
                                                                size={20}
                                                                style={{ color: "#083A4D" }}
                                                            />
                                                        }
                                                        onClick={() => PrintDocument(elem)}
                                                        startIcon={
                                                            <PrintIcon style={{ color: printLoaderArray.indexOf(elem.LAB_ORDER_N) > -1 ? "white" : "#083A4D" }} />
                                                        }
                                                    />
                                                </Tooltip>
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )
                ) : (
                    <div className="card " style={stylesbegin.container}>
                        <div
                            className="row"
                            style={{
                                paddingTop: "32px",
                                paddingBottom: matches == false ? "265px" : "32px",
                                paddingLeft: "10px",
                                backgroundColor: "#F5F5F5",
                            }}
                        >
                            <div className="col-sm-6">
                                <div className="card" style={stylestop.container}>
                                    <label
                                        className="card-text"
                                        style={{
                                            fontFamily: "Inter",
                                            fontSize: "16px",
                                            fontWeight: 400,
                                            lineHeight: "24px",
                                            letterSpacing: "0em",
                                            textAlign: "left",
                                            paddingBottom: "91px",
                                            paddingTop: "52px",
                                            paddingLeft: matches == false ? "16px" : "40px",
                                            height: "24px",
                                        }}
                                    >
                                        When you receive Lab Orders, they will be shown here.
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Grid>
            <ThemeProvider theme={theme}>
                <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
                    <DialogContent
                        style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                        }}
                    >
                        <CircularProgress style={{ color: "#083A4D" }} />
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={open}
                    onClose={() => {
                        setOpen(false);
                        setPdfUrl(null);
                        if (pdfUrl) URL.revokeObjectURL(pdfUrl);
                    }}
                    fullWidth
                    maxWidth={"lg"}
                >
                    <DialogContent
                        style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                            padding: 0,
                            flexDirection: "column", // Add this to allow column stacking for small screens
                        }}
                    >
                        {pdfUrl ? (
                            <iframe
                                src={pdfUrl}
                                style={{
                                    width: "100%",
                                    height: "80vh", // Set a responsive height
                                    border: "none",
                                }}
                                title="PDF Document"
                            />
                        ) : (
                            <Typography variant="body1" style={{ color: "#083A4D" }}>
                                No document available.
                            </Typography>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setOpen(false);
                                setPdfUrl(null);
                                if (pdfUrl) URL.revokeObjectURL(pdfUrl);
                            }}
                            style={{ color: "#083A4D" }}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        </>
    );
}

const button = {
    container: {
        backgroundColor: "#083A4D",
        color: "white",
    },
};

const stylestart = {
    container: {
        border: "1px grey",
        padding: "40px",
    },
};

const table = {
    container: {
        padding: "20px",
        border: "white",
    },
};

const stylesbegin = {
    container: {
        border: "1px grey",
        backgroundColor: "#F5F5F5",
    },
};
